import { render, staticRenderFns } from "./CustomerReview.vue?vue&type=template&id=cf2e415e&scoped=true&"
import script from "./CustomerReview.vue?vue&type=script&lang=js&"
export * from "./CustomerReview.vue?vue&type=script&lang=js&"
import style0 from "./CustomerReview.vue?vue&type=style&index=0&id=cf2e415e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2e415e",
  null
  
)

export default component.exports